const anxiety = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374263/anxiety_plvfhj.svg'
const sadness = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374300/sadness_nzdvsc.svg'
const anger = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374263/anger_pyosyr.svg'
const guilt = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374293/guilt_yabi7n.svg'
const shame = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374263/shame_xsfil7.svg'
const jealousy = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374295/jealousy_ypshi3.svg'
const frustration = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374267/frustration_svcbmf.svg'
const loneliness = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374300/loneliness_hmzcdc.svg'
const despair = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374264/despair_ztmokl.svg'
const happiness = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374294/happiness_wyiokm.svg'
const excitement = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374265/excitement_uuingh.svg'
const fear = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374265/fear_pmzgy7.svg'
const gratitude = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374268/gratitude_fenyie.svg'
const calmness = 'https://res.cloudinary.com/artieve-test/image/upload/v1762374264/calmness_cresnq.svg'

const moodData = [
    {
        mood: "Anxiety",
        icon: anxiety,
        subtitle: "Anxiety can feel overwhelming, but it also shows you care. Recognizing when it rises and falls can help you find balance and regain control."
    },
    {
        mood: "Sadness",
        icon: sadness,
        subtitle: "Sadness is a natural part of life. Giving yourself space to feel it can help you process emotions and find comfort in what brings you peace."
    },
    {
        mood: "Anger",
        icon: anger,
        subtitle: "Anger often signals that something important to you needs attention. Understanding its patterns can help you express it in healthy ways."
    },
    {
        mood: "Guilt",
        icon: guilt,
        subtitle: "Guilt can be a sign of strong values, but too much can weigh you down. Noticing when it appears may help you find self-compassion."
    },
    {
        mood: "Shame",
        icon: shame,
        subtitle: "Shame can make you feel alone, but you are never unworthy. Tracking it over time can help you challenge negative self-perceptions."
    },
    {
        mood: "Jealousy",
        icon: jealousy,
        subtitle: "Jealousy is a reminder of what you desire. Recognizing it can help you turn comparison into motivation for your own growth."
    },
    {
        mood: "Frustration",
        icon: frustration,
        subtitle: "Frustration often arises when things don’t go as planned. Identifying its sources can help you find patience and new solutions."
    },
    {
        mood: "Loneliness",
        icon: loneliness,
        subtitle: "Loneliness doesn’t mean you’re alone. Tracking it can help you recognize when to seek connection and nurture the relationships that matter."
    },
    {
        mood: "Despair",
        icon: despair,
        subtitle: "Despair can feel heavy, but it is not forever. Noticing its patterns may help you find hope in the moments that bring you light."
    },
    {
        mood: "Happiness",
        icon: happiness,
        subtitle: "Happiness can be fleeting, but recognizing what brings it to you can help you invite more joy into your life."
    },
    {
        mood: "Excitement",
        icon: excitement,
        subtitle: "Excitement is a spark of energy and anticipation. Paying attention to what excites you can lead you toward passion and purpose."
    },
    {
        mood: "Fear",
        icon: fear,
        subtitle: "Fear is a natural response to uncertainty. Understanding when it arises can help you face challenges with courage and confidence."
    },
    {
        mood: "Gratitude",
        icon: gratitude,
        subtitle: "Gratitude helps shift focus to what brings you joy and fulfillment. Tracking it can remind you of the good, even on difficult days."
    },
    {
        mood: "Calmness",
        icon: calmness,
        subtitle: "Calmness is a moment of peace in a busy world. Noticing when you feel it can help you create more space for rest and mindfulness."
    },
]

export default moodData